import api from "./api";

const purchaseService = {
  getAll: (params?: Record<string, any>) =>
    api.get("/purchases", { params }),
  getById: (id: string) => api.get(`/purchases/${id}`),
  create: (data: any) => api.post("/purchases", data),
  updatePayment: (id: string, data: any) =>
    api.put(`/purchases/${id}/payment`, data),
  voidInvoice: (id: string, reason?: string) =>
    api.post(`/purchases/${id}/void`, { reason }),
  createReturn: (data: any) => api.post("/purchases/returns", data),
  getStats: () => api.get("/purchases/stats"),
};

export default purchaseService;
